import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=4a9af208&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=ts"
export * from "./CodeBlock.vue?vue&type=script&lang=ts"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=4a9af208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9af208",
  null
  
)

export default component.exports